/* unplugin-vue-components disabled */import script from "./botton.vue?vue&type=script&setup=true&lang=js"
export * from "./botton.vue?vue&type=script&setup=true&lang=js"

import "./botton.vue?vue&type=style&index=0&id=5a5eee20&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5eee20"]])

export default __exports__